import { render, staticRenderFns } from "./resignations.vue?vue&type=template&id=15331ef3&scoped=true"
import script from "./resignations.vue?vue&type=script&lang=js"
export * from "./resignations.vue?vue&type=script&lang=js"
import style0 from "./resignations.vue?vue&type=style&index=0&id=15331ef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15331ef3",
  null
  
)

export default component.exports